import React, { useEffect } from 'react';
import Script from 'react-load-script';

const AddThis = () => {

    const initAddThis = () => {
        window.addthis.init();
        window.addthis.update('share', 'url', window.location.href);
    };

    useEffect(() => {
        console.log("addthis.load");
        if (window.addthis) {
            console.log("addthis.init");
            window.addthis.init();
            window.addthis.update('share', 'url', window.location.href);
            window.addthis.toolbox('.addthis_toolbox')
        }
    }, []);

    return (
        <>
            <div className="addthis_toolbox addthis_default_style addthis_32x32_style">
                {// eslint-disable-next-line 
                }<a className="addthis_button_link"></a>
                {// eslint-disable-next-line
                }<a className="addthis_button_linkedin"></a>
                {// eslint-disable-next-line
                }<a className="addthis_button_facebook"></a>
                {// eslint-disable-next-line
                }<a className="addthis_button_twitter"></a>
            </div>
            <Script
                url="//s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5ec337872c359c40"
                onLoad={initAddThis} />
        </>
    );
}

export default AddThis;